function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 5.67626C0 4.1223 0.94964 3 2.41727 3H21.7554C23.223 3 24 4.2259 24 5.67626V19.2302C24 20.6115 22.6187 21.5612 21.3237 21.5612H2.5036C1.03597 21.5612 0 20.2662 0 19.2302V5.67626ZM1.92012 19.32C2.415 19.1797 3.44179 17.5859 4.12049 15.3971C4.30651 14.7972 4.49575 13.9913 4.70539 13.0985C5.45183 9.9197 6.45677 5.64001 8.495 5.64001C10.5582 5.64001 11.3617 7.25022 12.1574 8.84486C12.2061 8.94239 12.2547 9.03985 12.3036 9.13688C13.8943 12.2938 16.9735 18.0718 20.1601 18.2309V19.32H1.92012Z",
  fill: "#D18F1F"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.3526 15.8715V17.2236H11.9135V15.8715H10.4868V10.8429H8.94778C8.76898 11.1334 7.64561 11.9045 7.12793 11.9045V13.3013C7.64561 13.306 8.64354 12.8627 8.94778 12.4856V15.8715H7.3526Z",
  fill: "#D18F1F"
});
function SvgDay1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDay1);
export default __webpack_public_path__ + "static/media/day1.4c669dfce036762c84c4a6ee584c1ae7.svg";
export { ForwardRef as ReactComponent };